// extracted by mini-css-extract-plugin
export default {"LayoutHeader":"Layout-module__LayoutHeader--pSMxQ"};